/**
 * Non-Critical CSS Loader
 * Loads CSS files that are not needed for above-the-fold content
 * This improves initial page load performance by deferring non-essential styles
 */

import { loadNonCriticalCSS, loadCSS } from './utils/cssLoader';

/**
 * Load all non-critical CSS files asynchronously
 * These files are not needed for the initial page render
 */
export function loadNonCriticalStyles() {
  // List of non-critical CSS files that can be loaded after initial render
  // Only including CSS for libraries that are actually used in the codebase
  const nonCriticalCSS = [
    // Date picker styles (only needed when date pickers are used)
    'bootstrap-daterangepicker/daterangepicker.css',
    'react-datepicker/dist/react-datepicker.css',
    
    // Social login styles (only needed for social login buttons)
    'bootstrap-social/bootstrap-social.css',
    
    // Flag icons (only needed for country flag displays)
    'flag-icon-css/css/flag-icon.min.css'
  ];

  // Load all non-critical CSS files
  const loadPromises = nonCriticalCSS.map(cssPath => 
    loadNonCriticalCSS(cssPath).catch(error => {
      console.warn(`Failed to load non-critical CSS: ${cssPath}`, error);
    })
  );

  return Promise.all(loadPromises);
}

/**
 * Load critical CSS files that are needed for above-the-fold content
 * These should be loaded synchronously to prevent FOUC
 */
export function loadCriticalStyles() {
  // Critical CSS files that are needed immediately
  const criticalCSS = [
    // Bootstrap - needed for layout and basic styling
    'bootstrap/dist/css/bootstrap.css',
    
    // FontAwesome - needed for icons used in navigation/header
    '@fortawesome/fontawesome-free/css/all.min.css',
    
    // Main application styles
    './index.css',
    './scss/react.scss'
  ];

  // Load critical CSS synchronously (these are already imported in index.js)
  // This function is here for documentation and potential future use
  return Promise.resolve();
}

/**
 * Initialize CSS loading strategy
 * Call this after the initial React render
 */
export function initializeCSSLoading() {
  // Load non-critical CSS after a short delay to not block initial render
  setTimeout(() => {
    loadNonCriticalStyles().then(() => {
      console.log('Non-critical CSS loaded successfully');
    }).catch(error => {
      console.error('Error loading non-critical CSS:', error);
    });
  }, 100); // Small delay to ensure initial render is complete
}
